import {
  flattenObject,
  getObjectPropertyByKey,
  patchObjectsByObjectId,
  SUB_EVENT_TYPES
} from '@/provider/utils';
import { useLazyQuery, useResult } from '@vue/apollo-composable';
import itemsSchema from '../api/object-management-items-list.graphql';
import { abcSort } from '@/compositions/sortBy';

export function useManagementItems({ object }) {
  const { id } = object;
  const { subscribeToMore, result, load } = useLazyQuery(
    itemsSchema.load,
    {
      objectId: id
    },
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only'
    }
  );

  const list = useResult(result, [], data =>
    data.objectsToObjects
      .map(i => {
        const property = getObjectPropertyByKey(i.object2, 'stateControlRpc');
        return {
          linked: !!property.value?.sourceId,
          ...flattenObject(i.object2)
        };
      })
      .sort((a, b) => abcSort(a.name, b.name))
  );

  subscribeToMore({
    document: itemsSchema.listenManagementItemsList,
    variables: {
      objectId: id
    },
    updateQuery: (previousResult, { subscriptionData }) => {
      console.log('object management items list subscription');
      const relatedNode = subscriptionData.data?.Objects?.relatedNode;
      const eventType = subscriptionData.data?.Objects?.event;
      if (eventType !== SUB_EVENT_TYPES.insert) return;
      if (!relatedNode) return;
      switch (relatedNode.__typename) {
        case 'ObjectsToObject': {
          return {
            objectsToObjects: [...previousResult.objectsToObjects, relatedNode]
          };
        }
        case 'ObjectProperty': {
          const { objectId } = relatedNode;
          const patchedObjects = patchObjectsByObjectId(
            objectId,
            'objectProperties',
            relatedNode,
            previousResult.objects
          );

          if (patchedObjects) {
            return {
              objects: patchedObjects
            };
          }
        }
      }
    }
  });

  return {
    load,
    list
  };
}
